export default __webpack_public_path__ + "static/media/mem.0c22bd33.png";